
// ProgressQueue
// A resillient queue for processing AJAX requests

function ProgressQueue() {
    if(typeof Offline !== 'undefined') {
      Offline.options = {
        checkOnLoad: true,
        interceptRequests: true,
        requests: false
      };
    }
    this.id = 'id';
    if(EF.enrollment) {
      this.id = EF.enrollment.get('id');
    }
    this.active = false;
    this.timeout = 5000;
    this.nextTimeout = 50;
    this.retryCount = 5;
    this.maxTryCount = 15;
    // scode these local storage keys to the user so we don't try to save
    // someone else's progress
    this.pending = new EF.Models.ArrayStorageWrapper('prog-' + this.id + '-pending');
    this.errors = new EF.Models.ArrayStorageWrapper('prog-' + this.id + '-errors');
    this.pending.concat(this.errors);
    this.completed = [];
    this.processing = null;
    this.paused = false;
    this.consecutiveFailures = 0;
    this.offlineCount = 0;
    this.successCount = 0;
    this.failureCount = 0;
    this.failureDelay = 3000; // initial delay of 3 seconds
    this.maxFailureDelay = 60000; // max delay of 1 minute
    // this.cors = false; // test cors=false manually by uncommenting this.

    _.bindAll(this, 'processNext', 'startProcessing', 'goOffline', 'goOnline', 'onBeforeUnload');

    this.registerOfflineListeners();

    // Start processing right away to pick up anything from last session.
    this.startProcessing();

    // TODO: initialize Queue watcher to check on the status of the queue
    // every once in a while to make sure its still working.
    // if its not working we should log something about that.
}

ProgressQueue.prototype = {

  statusReport: function() {
    return {
      active: this.active,
      paused: this.paused,
      pending: this.pending.length,
      errors: this.errors.length,
      successCount: this.successCount,
      failureCount: this.failureCount,
      processing: this.processing,
      networkState: (typeof Offline !== 'undefined' ? Offline.state : '?')
    };
  },

  registerOfflineListeners: function() {
    if(typeof Offline !== 'undefined') {
      // going from up to down
      Offline.on('down', this.goOffline);

      // going from down to up
      Offline.on('up', this.goOnline);
    }
  },

  removeOfflineListeners: function() {
    if(typeof Offline !== 'undefined') {
      Offline.off('down', this.goOffline);
      Offline.off('up', this.goOnline);
    }
  },

  goOnline: function() {
    this.log('Go online', {
      offlineCount: this.offlineCount,
      successCount: this.successCount,
      failureCount: this.failureCount,
      queueSize: this.pending.length,
      errorSize: this.errors.length,
      id: this.id
    });
    this.paused = false;
    this.startProcessing();
  },

  goOffline: function() {
    this.log('Go offline', {
      offlineCount: this.offlineCount,
      successCount: this.successCount,
      failureCount: this.failureCount,
      queueSize: this.pending.length,
      errorSize: this.errors.length,
      id: this.id
    });
    this.pause();
    this.offlineCount++;
  },

  pause: function(restartTimeout) {
    this.active = false;
    this.paused = true;
    this.processing = null;
    if(restartTimeout) {
      this.paused = false;
      var self = this;
      self.pauseTimer = setTimeout(function() {
        self.startProcessing();
      }, restartTimeout);
    }
  },

  enqueue: function(request) {
    request.tryCount = 0;
    this.pending.push(request);
    this.startProcessing();
  },

  startProcessing: function() {
    // if this offline check results in a change in network state for the better
    // it will unpause and call startProcessing again.
    if(this.paused) {
      this.checkOffline();
    }

    if(this.active || this.paused) return;
    clearInterval(this.pauseTimer);
    // console.log("startProcessing!");
    // console.log("Queue Length: ", this.pending.length);
    // console.log("Error Length: ", this.errors.length);
    // console.log("Completed Length: ", this.completed.length);
    // console.log("Queue Active?: ", this.active);
    // console.log("Queue Paused?: ", this.paused);
    // console.log("Queue Processing: ", this.processing);

    this.active = true;
    this.processNext();
  },

  retryFailures: function() {
    var self = this;
    // console.log("Lets retry some failures if we've got any!");
    // if not active again in 5000ms, requeue 3 failed requests
    setTimeout(function() {
      if(!self.active) {
        var retries = self.errors.splice(0, 3);
        if(retries.length > 0) {
          self.pending.concat(retries);
          self.startProcessing();
        }
      }
      else {
        // console.log("Guess I don't have any failures");
      }
    }, 5000);
  },

  processNext: function() {
    var self = this;

    // if paused or have a processing request, don't
    // process another request
    if(this.paused || this.processing) {
      return;
    }
    var nextRequest = this.pending.shift();
    if(nextRequest) {
      setTimeout(function() {
        self.processRequest(nextRequest);
      }, this.nextTimeout);
    }
    else {
      // console.log("No Next Request. Pausing.");
      this.active = false;
      this.processing = null;
      this.retryFailures();
    }
  },

  log: function(e, props) {
    console.log('progresss event: ', e, props);
  },

  onBeforeUnload: function() {
    // Don't process more right now
    this.pause(1);
    // If we have nothing pending, don't stop them
    if(this.pending.length === 0) return;

    var self = this;
    window.unload = function() {
      clearTimeout(self.pauseTimer);
    };

    // Return a delightful note to the user
    return 'Data is currently syncing to the server. Are you sure you want to leave?';
  },

  checkOffline: function() {
    if(typeof Offline !== 'undefined') {
      Offline.check();
    }
  },

  processRequest: function(request) {
    window.onbeforeunload = this.onBeforeUnload;

    var self = this,
      d = Date.now(),
      xhr,
      timer,
      errorCalled = false;

    this.processing = request;

    // console.log("Processing Request for: ", request.data.module_key);

    function errorCb(jqXHR, textStatus, errorThrown ) {
      // prevent it from getting executed twice
      if(errorCalled) return;
      clearTimeout(self.timer);
      errorCalled = true;
      var cancelled = (textStatus === undefined);
      self.userAborted = (jqXHR && jqXHR.getAllResponseHeaders() === '');
      var duration = Date.now() - d;
      if(self.xhr) { self.xhr.abort(); }
      self.checkOffline();
      self.processing = null;
      request.tryCount++;
      self.failureCount++;
      request.lastDuration = duration;
      self.consecutiveFailures++;

      self.log('Error Callback', {
        xhrError: textStatus,
        tryCount: request.tryCount,
        successCount: self.successCount,
        failureCount: self.failureCount,
        offlineCount: self.offlineCount,
        queueSize: self.pending.length,
        errorSize: self.errors.length,
        duration: duration,
        cancelled: cancelled,
        id: self.id
      });

      self.handleError(request);
    }

    function successCb(data, textStatus, jqXHR) {
      clearTimeout(self.timer);
      self.xhr = null;
      self.consecutiveFailures = 0;
      self.failureDelay = 3000;
      self.processing = null;
      self.successCount++;
      request.duration = Date.now() - d;
      self.completed.push(request);
      EF.trigger('page:progress:saved');
      self.processNext();
    }

    var options = EF.ContentProvider.ProgressService.getRequestOptions(request);
    this.xhr = $.ajax(options);
    this.xhr.always(function() {
      window.onbeforeunload = null;
    });
    this.xhr.done(successCb);
    this.xhr.fail(errorCb);
    this.timer = setTimeout(errorCb, this.timeout);
  },

  handleError: function(request) {
    var self = this;
    if(request.tryCount > self.retryCount) {
      // if it is above the max retries count, don't add back to the errors set
      if(request.tryCount < self.maxTryCount) {
        self.errors.push(request);
      }
      else {
        try {
          var c = window.LocalStorageWrapper.getItem('maxErrorsCount');
          c = parseInt((c || 0), 10);
          window.LocalStorageWrapper.setItem('maxErrorsCount', c++);
        }
        catch(e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
      }
      self.log('Max Tries Reached', {
        tryCount: request.tryCount,
        queueSize: self.pending.length,
        errorSize: self.errors.length
      });
    }
    else {
      self.pending.push(request);
    }

    if(!self.userAborted) {
      if(self.consecutiveFailures > 5) {
        self.pause(self.failureDelay);
        self.incrementFailureDelay();
      }
      else {
        self.processNext();
      }
    }
  },

  incrementFailureDelay: function() {
    this.failureDelay = this.failureDelay * 1.5;
    // enforce max failure delay
    if(this.failureDelay > this.maxFailureDelay) {
      this.failureDelay = this.maxFailureDelay;
    }
  },

  clear: function() {
    this.pending = [];
    this.errors = [];
    this.completed = [];
    this.active = false;
    this.processing = null;
    clearTimeout(this.timer);
    var _ = (this.xhr && this.xhr.abort && this.xhr.abort());
  },

  teardown: function() {
    this.active = false;
    this.processing = null;
    this.removeOfflineListeners();
  }

};

  _.extend(EF.Models, {
    ProgressQueue: ProgressQueue
  });
